import { render, staticRenderFns } from "./addRewardsAndAssessment.vue?vue&type=template&id=7eb575ca&scoped=true"
import script from "./addRewardsAndAssessment.vue?vue&type=script&lang=js"
export * from "./addRewardsAndAssessment.vue?vue&type=script&lang=js"
import style0 from "./addRewardsAndAssessment.vue?vue&type=style&index=0&id=7eb575ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb575ca",
  null
  
)

export default component.exports